import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ServiceRoleDataService from "../../services/ServiceRoleService";

const ServiceRole = (props) => {
  const cacheTitle = props.location.state?.cacheTitle ;
  console.log(`Last Info - props ${props.location.state?.cacheTitle}`);

  const initialServiceRoleState = {
    id: null,
    name: ""
  };
  const [currentServiceRole, setCurrentServiceRole] = useState(initialServiceRoleState);
  const [message, setMessage] = useState("");

  const getServiceRole = id => {
    ServiceRoleDataService.get(id)
      .then(response => {
        setCurrentServiceRole(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    console.log("get service role");
    getServiceRole(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentServiceRole({ ...currentServiceRole, [name]: value });
  };

  const updateServiceRole = () => {
    ServiceRoleDataService.update(currentServiceRole.id, currentServiceRole)
      .then(response => {
        console.log(response.data);
        setMessage("內容更新！");
        props.history.push({
          pathname: "/ServiceRoles",
          state: {
            cacheTitle: cacheTitle
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentServiceRole ? (
        <div className="edit-form">
          <h4>服務角色</h4>
          <form>
            <div className="form-group">
              <label htmlFor="name">名稱</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={currentServiceRole.name}
                onChange={handleInputChange}
              />
            </div>
          </form>

          <button
            type="submit"
            className="btn btn-success"
            onClick={updateServiceRole}
          >
            更新
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          {/* <p>Please click on a ServiceRole...</p> */}
        </div>
      )}
    </div>
  );
};

export default withRouter(ServiceRole);
